import {option, Option} from "ts-option";
import {RootState} from "../reducer/root/RootState";
import Brand from "../../model/brand/Brand";

/**
 * Gets brand by id.
 * @param {string} brandId Brand identifier to get.
 * @param {RootState} state State of the redux.
 * @returns {Option<Brand>} Brand.
 */
export function getBrand(brandId: string, state: RootState): Option<Brand> {
	return state.brand.brands.flatMap(brands => option(brands.filter(brand => brand.id === brandId)[0]));
}
